module.exports = __webpack_public_path__ + "static/3-f6951d9323125ad0cd03ed812aa2ec0a.jpg";